import { LoginResponsive } from '@/@http/auth/auth.DTO';
import { Permission, RouterList, User } from '@/@share/utils/modules';
import { setChecked } from '@/@share/utils/utils';
import { createStore } from 'vuex'

export default createStore({
  state: {
    expand: undefined as any,
    s: false,
    loading: false,
    darkMod: false,
    menuMod: 'light',
    accessRouters: [] as RouterList[],
    account: {} as User,
    permissions: [] as Permission[],
    store_id: '1111111111111111111',
    website_id: '1111111111111111111',
    langCode: 'vi',
    langList: [
      { code: 'vi', name: 'Tiếng Việt', },
      { code: 'en', name: 'English', }
    ] as any[],
    webList: [
      { id: "1111111111111111111", name: "dev.poloman.vn", },
      { id: "1111111111111111112", name: "test.poloman.vn" },
      { id: "1111111111111111113", name: "poloman.vn" }
    ] as any[],
    storeList: [
      { id: '1111111111111111111', name: 'tvtsolutions.com' },
      { id: '1111111111111111112', name: 'thy.morrow.vn' },
      { id: '1111111111111111113', name: 'morrow.vn' },
    ] as any[],
    searchText: '',
  },
  mutations: {
    checkLocalStoreData(state) {
      const website_id = localStorage.getItem('website_id');
      if (website_id && state.webList.find(e => e.id === website_id)) {
        state.website_id = website_id;
      }
      const store_id = localStorage.getItem('store_id');
      if (store_id && state.storeList.find(e => e.id === store_id)) {
        state.store_id = store_id;
      }
      const langCode = localStorage.getItem('langCode');
      if (langCode && state.langList.find(e => e.code === langCode)) {
        state.langCode = langCode;
      }
      return state;
    },
    setStore(state, store_id: string) {
      state.store_id = store_id;
      return state;
    },
    clearStore(state) {
      // state.store_id = undefined;
      return state;
    },
    setExpand(state, value: boolean) {
      state.expand = value;
      localStorage.setItem("MENU_EXPAND", state.expand ? "true" : "false");
      return state;
    },
    changeExpand(state) {
      state.expand = !state.expand;
      localStorage.setItem("MENU_EXPAND", state.expand ? "true" : "false");
      return state;
    },
    setDarkMod(state, value: boolean) {
      state.darkMod = value;
      const type = value ? 'dark' : 'light'
      const n = document.getElementsByTagName("body")[0];
      document.body.setAttribute("data-layout-mode", type),
        document.body.setAttribute("data-topbar", type),
        document.body.setAttribute("data-sidebar", type),
        n.hasAttribute("data-layout") &&
        "horizontal" == n.getAttribute("data-layout") || document.body.setAttribute("data-sidebar", type),
        setChecked(`topbar-color-${type}`);
      setChecked(`sidebar-color-${type}`);
      setChecked(`layout-mode-${type}`);
      if (state.darkMod) {
        (window as any).$('body').addClass("dark-theme");
        localStorage.setItem("DARK_THEME", "true");
      } else {
        (window as any).$('body').removeClass("dark-theme");
        localStorage.setItem("DARK_THEME", "false");
      }
      return state;
    },
    setMenuMod(state, value: string) {
      state.menuMod = value;
      localStorage.setItem("MENU_MOD", state.menuMod);
      return state;
    },
    setLoading(state, value: boolean) {
      state.loading = value;
      return state;
    },
    changeLoading(state) {
      state.loading = !state.loading;
      return state;
    },
    updateUserInfo(state, data: LoginResponsive) {
      state.accessRouters = data.menu;
      state.account = data.userInfo;
      state.permissions = data.permission;
      if(data.langList.length != 0 ) {
        state.langList = data.langList;
      } else {
        state.langList[0] = { code: 'vi', name: 'Tiếng Việt' }
      }
      if ( data.storeList === null ) {
        state.storeList[0] =  { id: '1111111111111111111', name: 'tvtsolutions.com' }
      } else {
        state.storeList = data.storeList;
      }
      if ( data.webList === null ) {
        state.webList[0] =  { id: "1111111111111111111", name: "dev.poloman.vn" }
      } else {
        state.webList = data.storeList;
      }

      state.website_id = data.userInfo.web_id;
      state.langCode = data.userInfo.lang_default;
      return state;
    },
    updateAccount(state, data) {
      return state.account = data;
    },
    resetData(state) {
      state.accessRouters = [];
      state.account = {} as User;
    }
  },
  getters: {
    account: state => {
      return state.account;
    },
    accessRouters: state => {
      return state.accessRouters.map(e => {
        if (e.children) {
          e.href = undefined;
        }
        return e;
      });
    },
    permissions: state => {
      return state.permissions;
    },
  },
  actions: {
  },
  modules: {
  }
})
